import React from 'react';

const SearchBox = ({ value, onChange, onSearch, onClear, placeholder = "Search item" }) => {
    return (
        <div className="searchbox w-100">
            <div className="input-group">
                <input
                    type="text"
                    className="form-control border-end-0"
                    id="searchQuery"
                    placeholder="Search"
                    aria-label="Search"
                    value={value}
                    onChange={onChange}
                    onKeyDown={(e) => e.key === 'Enter' && onSearch()}
                    style={{ borderColor: 'var(--accent-blue)', boxShadow: 'none' }}
                />
                {value && value.trim() !== '' && (
                    <button
                        className="btn border-top border-bottom"
                        type="button"
                        onClick={onClear}
                        aria-label="Clear search"
                        style={{ borderColor: 'var(--accent-blue)', backgroundColor: 'transparent', color: 'var(--accent-blue)' }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16" aria-hidden="true">
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                        </svg>
                    </button>
                )}
                <button
                    className="btn text-white px-4"
                    type="button"
                    id="searchButton"
                    onClick={onSearch}
                    aria-label="Search"
                    style={{ backgroundColor: 'var(--accent-blue)', borderColor: 'var(--accent-blue)', color: "white" }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16" aria-hidden="true">
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default SearchBox;
